//

/**
 * 将旧版本easc菜单数据转换为el-menu-item一致数据结构
 * @param {Array} menus
 */
export const convertEascV3Menus = (menus) => {
  if (!menus) return menus
  const newMenus = []
  menus.forEach((m) => {
    const newMenu = {
      index: m.url,
      icon: m.icon,
      title: m.name,
      isHomeMenu: m.isHomeMenu,
      openType: m.openType,
      hidden: m.hidden,
    }
    if (m.childrens) {
      newMenu.children = convertEascV3Menus(m.childrens)
    }
    newMenus.push(newMenu)
  })
  return newMenus
}

/**
 * 将route结构转换成menu结构
 * @param {object} route
 * @returns
 */
export const convertRouteToMenu = (route, parentPath) => {
  // 不需要处理 children
  let index = route.path
  if (parentPath && !index.startsWith('/')) {
    index = `${parentPath.replace(/\/$/, '')}/${index}`
  }
  return {
    index,
    icon: route.meta?.icon,
    title: route.meta?.title || 'NoTitle',
    isHomeMenu: route.meta?.isHomeMenu || false,
    openType: route.meta?.openType || 0,
    hidden: route.meta?.hidden || false,
  }
}

/**
 * 将routes转换成菜单，用于开发阶段；
 * @param {Array|Object} routes
 * @returns
 */
export const routesToMenus = (routes, parentPath = null) => {
  const menus = []
  if (!routes) return menus
  if (!Array.isArray(routes)) return routesToMenus([routes], parentPath)
  routes.forEach((r) => {
    if (r.meta && r.meta.hidden) {
      if (r.meta.inherit === false) {
        // 不继承父之隐藏特性，子菜单被动提一级别
        const p = `${parentPath}/${r.path}`
        const cm = routesToMenus(r.children, p)
        cm.forEach((m) => {
          menus.push(m)
        })
      }
    }
    const m = convertRouteToMenu(r, parentPath)
    if (r.children && r.children.length > 0) {
      const cm = routesToMenus(r.children, m.index)
      if (cm.length > 0) m.children = cm
    } else {
      delete m.children
    }
    menus.push(m)
  })
  return menus
}
